import React from "react";  
import {useParams } from "react-router-dom"; 
import RespondentSurveyPrivate from './RespondentSurveyPrivate';
import RespondentSurveyPublic from './RespondentSurveyPublic';

import "../../../styles/Menu.scss"; 
import "/node_modules/survey-core/defaultV2.css"; 

/**
 * The function is called when the survey is completed.
 */
export default function RespondentSurvey() {

    const { visible } = useParams(); 

    const showContentRespondent = () =>  {
        if (visible === 'private' ) {
            return <RespondentSurveyPrivate />;
        } else {
            return <RespondentSurveyPublic />;
        }
    }

    return showContentRespondent() ;

}